import React, { useMemo, useContext } from 'react';
import PropTypes from 'prop-types';
import If from 'ggApp/shared/components/Conditional';
import { Translator } from 'ggApp/modules/translator/components';
import { formatPriceByLanguage } from 'ggApp/utils/money';
import { CURRENCIES_ASSOCIATION } from 'ggApp/modules/store/constants';
import { OrderContext } from 'ggApp/shared/context/Order/OrderContext';
import { QtyBadge, QtyText } from 'ggApp/modules/auth/v3/components/ProductsInCart/styles';

import {
    Container,
    Image,
    ImageWrap,
    Content,
    MinMonths,
    Name,
    PriceInfo,
    PriceWrap,
    CoreAttribute,
} from './styles';

const LineItemCard = ({ className, item, shouldShowPrice }) => {
    const { activeStore } = useContext(OrderContext);

    const { name, price, minMonth, imgSrc, quantity, coreAttribute } = useMemo(() => {
        return {
            name: item.name,
            coreAttribute: item.coreAttribute,
            price: formatPriceByLanguage(
                item.totalCents,
                CURRENCIES_ASSOCIATION[activeStore.default_currency],
                activeStore.activeLanguage,
            ),
            minMonth: item.selectedPlan,
            imgSrc: item.imageUrl,
            quantity: item.quantity,
        };
    }, [activeStore, item]);

    return (
        <Container className={className}>
            <ImageWrap>
                <Image
                    src={imgSrc}
                    alt={name}
                    imgUrls={imgSrc}
                    sizes={{
                        default: '100%',
                    }}
                />

                <If condition={quantity !== null && quantity > 1}>
                    <QtyBadge>
                        <QtyText>{quantity}</QtyText>
                    </QtyBadge>
                </If>
            </ImageWrap>

            <Content>
                <Name>{name}</Name>

                {shouldShowPrice ? (
                    <PriceWrap>
                        {price && (
                            <PriceInfo>
                                <Translator tk="CART_PREVIEW_PER_MONTH" withValues={{ price }} />
                            </PriceInfo>
                        )}

                        {minMonth && (
                            <MinMonths>
                                <Translator
                                    tk="NEW_CHECKOUT_MIN_MONTHS"
                                    withValues={{ minMonth }}
                                />
                            </MinMonths>
                        )}
                    </PriceWrap>
                ) : (
                    <CoreAttribute>{coreAttribute}</CoreAttribute>
                )}
            </Content>
        </Container>
    );
};

LineItemCard.propTypes = {
    className: PropTypes.string,
    item: PropTypes.shape({
        name: PropTypes.string,
        price: PropTypes.string,
        minMonth: PropTypes.number,
        imgSrc: PropTypes.string,
        quantity: PropTypes.number,
    }),
    shouldShowPrice: PropTypes.bool,
};

LineItemCard.defaultProps = { className: '', item: {}, shouldShowPrice: true };

export { LineItemCard };
